<template>
  <li>
    <FormButton :class="btnClass" :loading="loading" :disabled="disabled" @click.prevent="$emit('click')"><slot /></FormButton>
  </li>
</template>

<script>
export default {
  name: 'FormWizardButton',
  props: {
    btnClass: {
      type: String,
      default: 'btn-primary'
    },
    loading: Boolean,
    disabled: Boolean
  }
}
</script>